import React, { Component } from 'react';
import PropTypes from 'prop-types';

import HeadersContainer from '../containers/HeadersContainer';
import BeiAn from './beian';
import Main from './Main';
import Bottom from './Bottom';
import cookie from '../utils/cookie';
import pcinfo from '../utils/pcid';
import { CURRENT_HOST } from '../constant';
import './App.css'

export default class App extends Component {
    static propTypes = {
        auto_login: PropTypes.func.isRequired,
        login_out: PropTypes.func.isRequired,
        user: PropTypes.string.isRequired,
        user_update: PropTypes.func.isRequired
    }
    componentDidMount() {
        const user = cookie.getCookie('user');
        setInterval(() => {
            if (this.props.user) {
                const req = fetch(`https://${CURRENT_HOST}/cookie_login`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: `openid=${this.props.user}&pcinfo=${pcinfo}`
                });
                req.then(r => r.json()).then((resp) => {
                    if (resp.state === 200) {
                        this.props.user_update(resp.data);
                    } else if (resp.state === 205) {//不在本机登录
                        this.props.login_out(true);
                    }
                });
            }
        }, 5000);
        if (user) {
            this.props.auto_login(pcinfo, user);
        }
    }
    render() {
        return (
            <div>
                <div className="soft-top">
                    <HeadersContainer />
                    <Main />
                </div>
                <Bottom />
                <BeiAn />
            </div>
        )
    }
}